import React from 'react';
import { I18n } from 'common/i18n';

const t = (key: string, scope = 'shared.dataset_management_ui.metadata_manage.dataset_tab') =>
  I18n.t(key, { scope });

const RestrictedFieldText = () => (
  <span className="restricted-field-text" slot="support-text">
    {t('subtitles.restricted_field')}
  </span>
);

export default RestrictedFieldText;
